<div class="report-loader-spinner-wrapper" [ngClass]="{visible: total}">
  <mat-progress-spinner
    class="report-loader-spinner"
    [mode]="done == 0 ? 'indeterminate' : 'determinate'"
    [value]="done/total*100"
    diameter="50">
  </mat-progress-spinner>
</div>
